import * as React from 'react'
import './InitializingPage.scss'

export class InitializingPage extends React.PureComponent {
  public render() {
    return (
      <div className='init-app-container'>
        <div className='init-app-inner-container'>
          <img src='/images/HBlogo_Square_Image_Only.png' />
          <div>Getting things ready...</div>
        </div>
      </div>
    )
  }
}
